import type { LinkStatus } from "shared";

export function shortUrl(hash: string, origin = window.location.origin): string {
	return `${origin}/${hash}`;
}

export function statusLabel(status: LinkStatus): string {
	switch (status) {
		case "live":
			return "Live";
		case "disabled":
			return "Disabled";
		case "not-started":
			return "Not started";
		case "expired":
			return "Expired";
	}
}

export function statusClass(status: LinkStatus): string {
	switch (status) {
		case "live":
			return "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400";
		case "disabled":
			return "bg-zinc-500/15 text-zinc-600 dark:text-zinc-400";
		case "not-started":
			return "bg-amber-500/15 text-amber-700 dark:text-amber-400";
		case "expired":
			return "bg-rose-500/15 text-rose-700 dark:text-rose-400";
	}
}

export function formatDt(value: string | null | undefined): string {
	if (!value) return "—";
	const ms = Date.parse(value.replace(" ", "T") + "Z");
	if (!Number.isFinite(ms)) return value;
	const d = new Date(ms);
	const p = (n: number) => String(n).padStart(2, "0");
	return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

export async function copyText(text: string): Promise<boolean> {
	try {
		await navigator.clipboard.writeText(text);
		return true;
	} catch {
		try {
			const ta = document.createElement("textarea");
			ta.value = text;
			ta.style.position = "fixed";
			ta.style.left = "-9999px";
			document.body.appendChild(ta);
			ta.select();
			const ok = document.execCommand("copy");
			document.body.removeChild(ta);
			return ok;
		} catch {
			return false;
		}
	}
}
